<template>
  <v-container fluid grid-list-md text-xs-center>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card dark color="primary">
          <v-toolbar card>
            <v-icon>domain</v-icon>
            <v-toolbar-title class="font-weight-light">
              Edición de Inmueble <v-icon>mdi-chevron-right</v-icon>
              {{ refCatastral }} <v-icon>mdi-chevron-right</v-icon>
              {{ idInmueble }}
            </v-toolbar-title>
            <!-- <v-spacer></v-spacer>
                        <v-btn small outline color="red">
                            Eliminar Inmueble
                        </v-btn>
                        <v-btn small outline color="white">
                            Agregar Inmueble
                        </v-btn> -->
            <v-spacer></v-spacer>
            <v-toolbar-title class="font-weight-light">
              <v-btn
                @click="prevNextInmueble('start')"
                flat
                icon
                outline
                color="white"
                :disabled="referInmuebleArray.index < 1"
              >
                <v-icon>mdi-chevron-double-left</v-icon>
              </v-btn>
              <v-btn
                @click="prevNextInmueble(-1)"
                flat
                icon
                outline
                color="white"
                :disabled="referInmuebleArray.index < 1"
              >
                <v-icon>mdi-chevron-left</v-icon>
              </v-btn>
              {{ referInmuebleArray.index + 1 }} /
              {{ referInmuebleArray.total }}
              <v-btn
                @click="prevNextInmueble(+1)"
                flat
                icon
                outline
                color="white"
                :disabled="
                  referInmuebleArray.index > referInmuebleArray.total - 2
                "
              >
                <v-icon>mdi-chevron-right</v-icon>
              </v-btn>
              <v-btn
                @click="prevNextInmueble('end')"
                flat
                icon
                outline
                color="white"
                :disabled="
                  referInmuebleArray.index > referInmuebleArray.total - 2
                "
              >
                <v-icon>mdi-chevron-double-right</v-icon>
              </v-btn>
            </v-toolbar-title>
          </v-toolbar>
        </v-card>
      </v-flex>
      <!-- Datos -->
      <v-flex xs4>
        <v-card>
          <v-toolbar card>
            <v-icon>domain</v-icon>
            <v-toolbar-title class="font-weight-light">
              Datos Inmueble
            </v-toolbar-title>
          </v-toolbar>
          <v-card-text class="px-5 blue--text">
            <v-flex xs12>
              <v-text-field label="Dirección" v-model="inmuebleDatos.direccion">
              </v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-layout row justify-space-between>
                <v-flex xs3>
                  <v-text-field
                    label="Escalera"
                    v-model="inmuebleDatos.escalera"
                  >
                  </v-text-field>
                </v-flex>
                <v-flex xs3>
                  <v-text-field label="Piso" v-model="inmuebleDatos.piso">
                  </v-text-field>
                </v-flex>
                <v-flex xs3>
                  <v-text-field label="Letra" v-model="inmuebleDatos.letra">
                  </v-text-field>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12>
              <v-text-field label="Uso" v-model="inmuebleDatos.uso">
              </v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-layout row justify-space-between>
                <v-flex xs3>
                  <v-text-field
                    suffix="m2"
                    label="Superficie"
                    v-model="inmuebleDatos.superficie"
                  >
                  </v-text-field>
                </v-flex>
                <v-flex xs3>
                  <v-text-field
                    suffix="%"
                    label="Cuota"
                    v-model="inmuebleDatos.cuota"
                  >
                  </v-text-field>
                </v-flex>
                <v-flex xs3>
                  <v-text-field
                    suffix="Año"
                    label="Antigüedad"
                    v-model="inmuebleDatos.year"
                  >
                  </v-text-field>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12>
              <v-checkbox
                slot="activator"
                class="py-0"
                label="¿Participa?"
                v-model="inmuebleDatos.participa"
              >
              </v-checkbox>
            </v-flex>
          </v-card-text>
          <v-card-actions>
            <!-- <v-tooltip top>
                            <v-checkbox
                                slot="activator"
                                class="py-0"
                                label="Cumple Requisito Económico"
                                v-model="inmuebleDatos.cumpleRequisitoEcon">
                            </v-checkbox>
                            <span>Cumple, o no, con el requisito de renta máxima para 35% de ayuda Adicional</span>
                        </v-tooltip> -->
            <v-spacer></v-spacer>
            <v-btn color="success" @click.stop="inmuebleDatosUpdate">
              Guardar
              <v-icon right dark>save</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
      <!-- Usuarios -->
      <v-flex xs8>
        <v-card>
          <v-toolbar card>
            <v-icon>people</v-icon>
            <v-toolbar-title class="font-weight-light">
              Propietarios / Inquilinos
              {{ inmuebleUsers ? `[${inmuebleUsers.length}]` : "" }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn small fab dark :color="temaColor">
              <v-icon @click="buscaUsuario" dark>add</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text class="px-0">
            <v-container grid-list-md text-xs-center v-if="inmuebleUsers">
              <v-layout row wrap>
                <v-flex xs4 v-for="(users, i) in inmuebleUsers" :key="i">
                  <v-card
                    :color="
                      users.mayor65
                        ? 'teal lighten-5'
                        : users.discapacidad
                        ? 'orange lighten-5'
                        : 'grey lighten-4'
                    "
                    class="elevation-3"
                  >
                    <v-card-title
                      :class="
                        users.mayor65
                          ? 'py-0 teal lighten-4'
                          : users.discapacidad
                          ? 'py-0 orange lighten-4'
                          : 'py-0 grey lighten-3'
                      "
                    >
                      <v-btn
                        small
                        outline
                        fab
                        color="primary"
                        @click="editarUsuario(users.id)"
                      >
                        <v-icon>create</v-icon>
                      </v-btn>
                      <template v-if="users.mayor65 || users.discapacidad">
                        <v-tooltip top>
                          <v-icon slot="activator" v-if="users.discapacidad"
                            >mdi-wheelchair-accessibility</v-icon
                          >
                          <span>Discapacidad</span>
                        </v-tooltip>
                        <v-tooltip top>
                          <v-icon slot="activator" v-if="users.mayor65"
                            >mdi-timelapse</v-icon
                          >
                          <span>Mayor 65 Años</span>
                        </v-tooltip>
                      </template>
                      <v-spacer></v-spacer>
                      <router-link :to="`/dashboard/perfil/${users.id}`">{{
                        composeUserName(users.id) || "-"
                      }}</router-link>

                      <!-- <v-btn small outline fab color="error" @click="deleteUsuario(users.id)">
                                                <v-icon>mdi-delete</v-icon>
                                            </v-btn> -->
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text class="px-2 py-0">
                      <v-flex xs12>
                        <v-layout row wrap>
                          <v-flex xs7 class="py-0">
                            <v-radio-group v-model="users.tipo">
                              <v-radio label="Propietario" value="0"> </v-radio>
                              <v-radio label="Inquilino" value="1"> </v-radio>
                            </v-radio-group>
                          </v-flex>
                          <v-flex xs5 v-if="users.tipo === '0'">
                            <v-text-field
                              class="py-3"
                              suffix="%"
                              type="number"
                              max="100"
                              label="% Propiedad"
                              v-model="users.cuota"
                            >
                            </v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-divider class="py-0"></v-divider>

                      <v-flex xs12 class="py-0">
                        <v-layout row wrap>
                          <v-flex xs8 class="py-0">
                            <!-- <v-checkbox
                                                            class="py-0"
                                                            label="Empadronado"
                                                            :value="empadronadoItems[users.padronStatusConocido]"
                                                            v-model="users.empadronado">
                                                        </v-checkbox> -->
                            <v-combobox
                              @change="changePadron(i)"
                              v-model="inmuebleUsersFilter[i]"
                              :items="empadronadoItems"
                              item-text="text"
                              item-value="value"
                            >
                            </v-combobox>
                          </v-flex>
                          <v-flex xs4 text-xs-right>
                            <!-- <v-spacer></v-spacer> -->
                            <v-btn
                              small
                              outline
                              fab
                              color="error"
                              @click="deleteUsuario(users.id)"
                            >
                              <v-icon>mdi-delete</v-icon>
                            </v-btn>
                          </v-flex>
                          <v-flex xs12 v-if="users.empadronado">
                            <v-checkbox
                              class="py-0"
                              label="Volante empadronamiento"
                              v-model="users.volante"
                            >
                            </v-checkbox>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <!-- <v-autocomplete
                                                v-model="users.tipo"
                                                :items="tipos">
                                            </v-autocomplete> -->
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
              <v-layout row wrap v-if="mostrarAnexo4">
                <v-flex xs12>
                  <v-tooltip top>
                    <v-checkbox
                      slot="activator"
                      class="py-0"
                      label="Anexo IV - Discapacidad / Mayor 65 Años"
                      v-model="inmuebleDatos.anexo4"
                    >
                    </v-checkbox>
                    <span>Marcar si se ha cumplimentado el Anexo IV</span>
                  </v-tooltip>
                </v-flex>
              </v-layout>
            </v-container>
            <v-container grid-list-md text-xs-center v-else>
              <p class="text-xs-center">
                Ningún Propietario / Inquilino seleccionado
              </p>
            </v-container>
            <!-- <v-data-table 
                            rows-per-page-text="Resultados por página" 
                            :headers="usersHeaders"
                            :items="inmuebleUsers" 
                            class="elevation-1">
                            <template slot="items" slot-scope="users">
                                <tr @click="users.expanded = !users.expanded">
                                    <td>
                                        <router-link :to="`/dashboard/perfil/${users.item.id}`">{{ composeUserName(users.item.id) || '-' }}</router-link>
                                    </td>
                                    <td class="text-xs-center">
                                        <v-autocomplete
                                            v-model="users.item.tipo"
                                            :items="tipos">
                                        </v-autocomplete>
                                    </td>
                                    <td v-if="users.item.tipo === tipos[0]" class="text-xs-center">
                                        <v-text-field 
                                            suffix="%"
                                            type="number"
                                            max="100"
                                            v-model="users.item.cuota">
                                        </v-text-field>
                                    </td>
                                    <td v-else class="text-xs-center">N/A</td>
                                    <td class="text-xs-right">
                                        <v-checkbox v-model="users.item.empadronado"></v-checkbox>    
                                    </td>
                                </tr>
                            </template>
                            <template slot="expand" slot-scope="users">
                                <v-card flat>
                                    <v-card-text>
                                        <v-btn small outline fab color="error" @click="deleteUsuario(users.item.id)">
                                            <v-icon>mdi-delete</v-icon>
                                        </v-btn>
                                        <v-btn small outline fab color="primary" @click="editarUsuario(users.item.id)">
                                            <v-icon>create</v-icon>
                                        </v-btn>
                                    </v-card-text>
                                </v-card>
                            </template>
                            <template slot="no-data">
                                <v-alert :value="true" color="info" icon="info">
                                No existen documentos :(
                                </v-alert>
                            </template>
                        </v-data-table> -->
          </v-card-text>

          <v-card-actions>
            <v-tooltip top>
              <v-checkbox
                slot="activator"
                class="py-0"
                label="Anexo III - Renta inferior al máximo"
                v-model="inmuebleDatos.cumpleRequisitoEcon"
              >
              </v-checkbox>
              <span
                >Marcar si cumple con el requisito de renta máxima para 35% de
                ayuda Adicional</span
              >
            </v-tooltip>
            <v-spacer></v-spacer>
            <v-btn color="success" @click.stop="inmuebleUserUpdate">
              Guardar
              <v-icon right dark>save</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>

      <!-- Notas -->
      <v-flex xs4>
        <v-card color="red lighten-5">
          <v-card-text>
            <v-flex xs12>
              <v-textarea
                v-model="inmuebleDatos.notas"
                label="Notas internas"
              ></v-textarea>
            </v-flex>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="success" @click.stop="inmuebleDatosUpdate">
              Guardar
              <v-icon right dark>save</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
    <v-snackbar v-model="hecho" :timeout="hechoTimeOut" top>
      Hecho !!
      <v-btn color="pink" flat @click="hecho = false">
        cerrar
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
export default {
  name: "admin-inmueble-detalle",
  data() {
    return {
      empadronado: 0,
      mostrarAnexo4: false,
      empadronadoItems: [
        {
          text: "¿Está Empadronado?",
          value: 0
        },
        {
          text: "No empadronado",
          value: 1
        },
        {
          text: "Empadronado",
          value: 2
        }
      ],
      usersHeaders: [
        { text: "Nombre", value: "usuario", align: "left" },
        { text: "Tipo", value: "tipo", align: "center" },
        { text: "% Propiedad", value: "cuota", align: "center" },
        {
          text: "Empadronado",
          value: "empadronado",
          align: "right"
        } /* ,
                { text: 'Acciones', value: '', sortable: false } */
      ],
      tipos: ["Propietario", "Inquilino"],
      hecho: false,
      hechoTimeOut: 6000,
      inmuebleDatos: null,
      inmuebleUsers: null
    };
  },
  watch: {
    idInmueble() {
      this.updateInmueble();
      this.updateUsers();
    }
  },
  created() {
    this.updateInmueble();
    this.updateUsers();
  },
  methods: {
    changePadron(i) {
      const valor = this.inmuebleUsersFilter[i].value;
      this.empadronado = {
        cambioID: this.inmuebleUsers[i].id,
        valor: valor
      };
      this.inmuebleUsers[i].padronStatusConocido = this.inmuebleUsersFilter[
        i
      ].value;
      if (valor > 1) {
        this.inmuebleUsers[i].empadronado = true;
      } else {
        this.inmuebleUsers[i].empadronado = false;
      }
    },
    prevNextInmueble(op) {
      let index = this.referInmuebleArray.index;
      if (op === "start" || op === "end") {
        index = op === "start" ? 0 : this.listaInmueblesArray.length - 1;
      } else {
        index += op;
      }
      const ref = this.listaInmueblesArray[index];
      this.$router.replace(
        `/dashboard/inmuebles-detalle/${this.refCatastral}/${ref}`
      );
    },
    editarUsuario(idx) {
      this.$router.push(`/dashboard/perfil/${idx}`);
    },
    deleteUsuario(idx) {
      /* const array = this.inmuebleUsers.map(item => item.idx)
            const indice = array.indexOf(idx); // obtenemos el indice
            this.inmuebleUsers.splice(indice, 1) */
      const payload = {
        refCatastral: this.refCatastral,
        idInmueble: this.idInmueble,
        inmuebleUser: this.inmuebleDatos.refCat,
        idUser: idx
      };
      this.$store.dispatch(
        "deleteUserInmueble",
        payload
      ); /* .then(() => {
                this.updateUsers()
                this.hecho = true
            }) */
    },
    inmuebleDatosUpdate() {
      const payload = {
        refCatastral: this.refCatastral,
        idInmueble: this.idInmueble,
        inmuebleDatos: this.inmuebleDatos
      };
      this.$store.dispatch("inmuebleDatosUpdate", payload);
      this.hecho = true;
      /* .then(() => {
                // this.updateUsers()
                
            }) */
    },
    inmuebleUserUpdate() {
      const payload = {
        refCatastral: this.refCatastral,
        idInmueble: this.idInmueble,
        inmuebleUsers: this.inmuebleUsers
      };
      this.$store.dispatch(
        "inmuebleUserUpdate",
        payload
      ); /* .then(() => {
                // this.updateUsers()
                this.hecho = true
            }) */
      this.inmuebleDatosUpdate();
    },
    updateInmueble() {
      this.inmuebleDatos = this.dataInmueble
        ? this.dataInmueble.inmueble
        : null;
    },
    updateUsers() {
      this.inmuebleUsers = this.catastroUsers
        ? this.catastroUsers.map(item => {
            const especial = this.$store.getters.isMayor65OrDiscapacidad(
              item.id
            );
            if (
              especial.mayor65 ||
              (especial.discapacidad && especial.discapacidad.isDiscapacidad)
            ) {
              this.mostrarAnexo4 = true;
            }
            return {
              cuota: item.cuota,
              empadronado: item.empadronado,
              padronStatusConocido: item.empadronado
                ? 2
                : item.padronStatusConocido
                ? item.padronStatusConocido
                : 0,
              volante: item.volante ? item.volante : false,
              id: item.id,
              tipo: item.tipo,
              discapacidad: especial.discapacidad,
              mayor65: especial.mayor65
            };
          })
        : [];
    },
    buscaUsuario() {
      this.$router.push(
        `/dashboard/usuarios/inmuebleSelectUser?filter=Usuario&refCatastral=${
          this.refCatastral
        }&idInmueble=${this.idInmueble}&inmuebleUser=${
          this.inmuebleDatos.refCat
        }`
      );
    },
    composeUserName(idx) {
      const maxLength = 20;
      let usuario = this.$store.state.users[idx] || null;
      if (usuario) {
        usuario = `${usuario.private.nombre} ${usuario.private.apellido1} ${
          usuario.private.apellido2
        }`;
      }
      if (usuario.length > maxLength) {
        usuario = `${usuario.substr(0, maxLength)} ...`;
      }
      return usuario;
    }
  },
  computed: {
    /* prueba() {
            return this.$store.getters.isMayor65OrDiscapacidad('MFMyMjNUOS0xNTQzMzk5NjA0MDgx')
        },
        prueba2() {
            let result = {
                mayor65: false,
                discapacidad: false
            }
            const user = this.$store.getters.getUsuarioId('MFMyMjNUOS0xNTQzMzk5NjA0MDgx').private
            if (user) {
                const discapacidad = user.discapacidad || false
                if (discapacidad && discapacidad.isDiscapacidad ) {
                    result.discapacidad = discapacidad
                }
                if (user.fechaNacimientoYear && user.fechaNacimientoMes && user.fechaNacimientoDia) {
                    const fechaHoy = new Date()
                    const fNacimiento = new Date(`${1953}-${10}-${10}`)
                    const difYear = fechaHoy.getFullYear() - fNacimiento.getFullYear()
                    if (difYear > 65) {
                        result.mayor65 = difYear
                        result.validado = 'Por año'
                    }
                    // Afinar en el mes y día
                    if (difYear === 65) {
                        const difMes = fechaHoy.getMonth() - fNacimiento.getMonth()
                        // Mes
                        if (difMes > 0) {
                            result.mayor65 = difYear
                            result.validado = 'Por mes'
                        }
                        // Día
                        if (difMes === 0) {
                            const difDia = fechaHoy.getDate() - fNacimiento.getDate()
                            if (difDia > -1) {
                                result.mayor65 = difYear
                                result.validado = 'Por dia'
                            }
                        }
                    }
                }
            }
            return result
        }, */
    inmuebleUsersFilter() {
      //empadronadoItems[users.padronStatusConocido]
      // padronStatusConocido => 0: Desconocido, 1: No Empadronado, 2: Empadronado
      return this.inmuebleUsers.map(
        item => this.empadronadoItems[item.padronStatusConocido]
      );
    },
    temaColor() {
      return this.$store.getters.getTemaColorAdminUI;
    },
    refCatastral() {
      return this.$route.params.ref;
    },
    idInmueble() {
      return this.$route.params.id;
    },
    dataInmueble() {
      if (this.refCatastral && this.idInmueble) {
        const payload = {
          refCatastral: this.refCatastral,
          id: this.idInmueble
        };
        return this.$store.getters.getInmuebleId(payload);
      }
      return {};
    },
    /* editandoInmueble() {
            if (this.dataInmueble) {
                return this.dataInmueble.inmueble
            }
            return {}
        }, */
    catastroUsers() {
      if (this.dataInmueble) {
        return this.dataInmueble.catastroUsers;
      }
      return [];
    },
    // Para recorrer los inmuebles
    catastroData() {
      return this.$store.getters.getCatastroId(this.refCatastral);
    },
    listaInmuebles() {
      if (this.catastroData) {
        return this.catastroData.inmuebles;
      }
      return {};
    },
    listaInmueblesArray() {
      if (this.listaInmuebles) {
        return Object.keys(this.listaInmuebles).map(i => i);
      }
      return [];
    },
    referInmuebleArray() {
      const index = this.listaInmueblesArray.indexOf(this.idInmueble);
      const total = this.listaInmueblesArray.length;
      const result = {
        index: index,
        total: total
      };
      return result;
    }
    /* filterUsers() {
            if (this.catastroUsers) {
                const users = this.catastroUsers.map(item => item.id)
                const usersData = this.$store.getters.getUsersArray.filter(item => users.includes(item.idx)).map(item => `${item.data.private.nombre} ${item.data.private.apellidos}`)
                return usersData
            }
            return []
        }, */
    /* renderListUsers() {
            if (this.catastroUsers) {
                return this.catastroUsers.map((item, i) => {
                    let usuario =  this.$store.state.users[item.id] || null
                    if (usuario) {
                        usuario = `${usuario.private.nombre} ${usuario.private.apellidos}`
                    }
                    return {
                        cuota: item.cuota,
                        empadronado: item.empadronado,
                        tipo: item.tipo ? this.tipos[item.tipo] : false,
                        usuario: usuario
                    }
                })
            }
            return []
        } */
  }
};
</script>
